// "Card style" picker: shows a preview of every deck, the chosen one is saved on the device and every
// card in the game switches to it straight away (see CardUtils.setDeck / the 'card-deck-changed' event).
import React from 'react';
import { createPortal } from 'react-dom';
import CardUtils, { CARD_DECKS } from '../../../utils/CardUtils';

const CardDeckPicker = ({ show, onClose, current, onChoose, isMobile = false }) => {
  if (!show) return null;
  const cardW = isMobile ? 38 : 46;
  const cardH = Math.round(cardW * 1.4);
  const sample = [
    { rank: 'A', suit: 'spades' },
    { rank: 'K', suit: 'hearts' },
    { rank: '10', suit: 'diamonds' },
  ];
  return createPortal(
    <div
      onClick={onClose}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.65)', zIndex: 100000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 12 }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ background: '#f7f8fb', color: '#1b1f2a', borderRadius: 14, padding: isMobile ? '14px 14px' : '20px 24px', maxWidth: 520, width: '94vw', maxHeight: '86vh', overflowY: 'auto', boxShadow: '0 10px 40px rgba(0,0,0,0.5)' }}
      >
        <h3 style={{ margin: '0 0 4px 0', fontSize: isMobile ? 17 : 20 }}>🃏 Card style</h3>
        <p style={{ margin: '0 0 12px 0', fontSize: 12, color: '#566' }}>Choose the cards that are easiest for you to read.</p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {CARD_DECKS.map((d) => {
            const base = CardUtils.getDeckBase(d.id);
            const selected = d.id === current;
            return (
              <button
                key={d.id}
                onClick={() => { onChoose(d.id); }}
                style={{
                  display: 'flex', alignItems: 'center', gap: 12, textAlign: 'left', cursor: 'pointer',
                  background: selected ? '#e8f5e9' : '#fff', border: selected ? '2px solid #2e7d32' : '1px solid #cfd6e4',
                  borderRadius: 10, padding: '8px 10px'
                }}
              >
                <div style={{ display: 'flex', gap: 4, flexShrink: 0 }}>
                  {sample.map((c) => (
                    <img
                      key={c.rank + c.suit}
                      src={`${base}/${({ A: 'ace', K: 'king', Q: 'queen', J: 'jack' }[c.rank]) || c.rank}_of_${c.suit}.png`}
                      alt=""
                      draggable={false}
                      style={{ width: cardW, height: cardH, objectFit: 'contain', borderRadius: 4, background: '#fff', border: '1px solid #ddd' }}
                      onError={(e) => { e.target.style.visibility = 'hidden'; }}
                    />
                  ))}
                  <img
                    src={`${base}/card_back.png`} alt="" draggable={false}
                    style={{ width: cardW, height: cardH, objectFit: 'contain', borderRadius: 4, background: '#fff', border: '1px solid #ddd' }}
                    onError={(e) => { e.target.onerror = null; e.target.src = '/cards/design2/card_back.png'; }}
                  />
                </div>
                <div style={{ flex: 1, fontWeight: 700, fontSize: isMobile ? 14 : 16 }}>{d.name}</div>
                {selected && <span style={{ color: '#2e7d32', fontWeight: 800 }}>✓ In use</span>}
              </button>
            );
          })}
        </div>
        <div style={{ textAlign: 'right', marginTop: 14 }}>
          <button onClick={onClose} style={{ background: '#607d8b', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 22px', fontWeight: 700, cursor: 'pointer' }}>Done</button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default CardDeckPicker;
